import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import M from "materialize-css/dist/js/materialize.min.js";

import PropTypes from 'prop-types';

import {withRouter} from 'react-router-dom';

//Sub Items
import Refresh from './refresh.jsx'
import SetHelp from './setHelp.jsx'
import PendingTransactions from './pendingTransactions.jsx'
import ScheduledEvents from './scheduledEvents';
import Height from './height.jsx'
import Settings from './settings.jsx';
import Status from './status.jsx';
import SideStatus from './sideStatus.jsx';

import Portfolio from './portfolio.jsx';
import Downloads from './download.jsx';
import Ticker from './ticker.jsx';
import $ from 'jquery';

//CSS Import
import './header.css'
import {setMarket} from '../../actions/ui/marketplace';
import {setAssetView} from '../../actions/ui/passport';

import {assets} from '../../config';
import isElectron from 'is-electron';

class Header extends Component {
  state = this.props.settings;
  static contextTypes = {
    router: PropTypes.object
  };
  componentDidMount(){
    let pair = this.props.location.search ? this.props.location.search.substring(1) : null;
    let type = this.props.location.hash ? this.props.location.hash.substring(1) : null;

    if(type && type.length > 1 && pair && pair.length > 1){
      let [asset,denomination] = pair.split('/');
      // this.props.setMarket({type,denomination,asset})
    }
    else if(pair && pair.length > 1 && !pair.includes('/')){
      // this.props.setAssetView(pair);
    }
    let _this = this;
    document.addEventListener('DOMContentLoaded', function() {
      var elem = document.querySelectorAll('.sidenav');
      var instance = M.Sidenav.init(elem);
    });
  }
  componentWillReceiveProps(newProps){
    if(this.props.location.search != newProps.location.search){
      let pair = newProps.location.search ? newProps.location.search.substring(1) : null;
      let type = newProps.location.hash ? newProps.location.hash.substring(1) : null;
      if(type){
        let [asset,denomination] = pair.split('/');
        // this.props.setMarket({type,denomination,asset})
      }
      else if(pair){
        // this.props.setAssetView(pair);
      }
    }
  }
  // <li><Link to="/marketplace" className="borderless" style={{paddingRight:0}}>
  // <img src={`./overline.png`}  style={{height:'30px',marginTop:'5px',paddingRight:0}} />
  // </Link></li>
  left(){
    let marketplaceDisplay = this.props.location.pathname == '/marketplace' ? 'white' : 'grey';
    return (
      <ul className="left">
        <li><Link to="/" className="borderless">OVERLINE</Link></li>
        <Portfolio/>
      </ul>
    )
  }
  right(){
    return (
      <>
        <ul className='right hide-on-small-and-down'>
          <PendingTransactions/>
          <li>
            <a style={{cursor:'pointer'}} onClick={this.openSettings.bind(this)}>
              <i className="material-icons icon" >
                power_settings_new
              </i>
            </a>
          </li>
          <Refresh/>
          <Height/>
        </ul>
        <Settings/>
      </>
    )
  }
  openSettings(){
    let _this = this;
    console.log(document.querySelectorAll("#modalSettings"))
    if (document.querySelectorAll("#modalSettings")[0]) {
      var instance = M.Modal.getInstance(document.querySelectorAll("#modalSettings")[0]);
      if (instance) instance.open();
      setTimeout(() => {
        // _this.props.networksettings.forEach(({ id }) => {
        //   $(`#${id}`)[0].value = _this.state[id];
        // });
      }, 100);
    }
    var elem = document.querySelectorAll('.sidenav');
    instance = M.Sidenav.getInstance(elem[0]);
    instance.close()
  }
  closeInstance(){
    var elem = document.querySelectorAll('.sidenav');
    let instance = M.Sidenav.getInstance(elem[0]);
    instance.close()
  }
  sidebar(){
    return (
      <ul id="slide-out" className="sidenav">
        <li>
          <a style={{cursor:'pointer'}} onClick={this.openSettings.bind(this)}>
            <i className="material-icons icon" >
              power_settings_new
            </i>
            Settings
          </a>
        </li>
        <Refresh text={true}/>
        <SideStatus text={true}/>
        <li><div className="divider"></div></li>
        <li><Link onClick={this.closeInstance.bind(this)} to="/media" className="borderless">Alternative Assets</Link></li>
      </ul>
    )
  }
  render() {
    return (
      <>
        <div className='minWidth fixedTop' >
          <nav className="navbar-fixed" >
            <div className="">
            {this.left()}
            {this.right()}
            </div>
          </nav>
        </div>
        {this.sidebar()}
        <Ticker display={this.props.location.pathname === '/marketplace' ? 'block' : 'none'}/>
      </>
    );
  }
}

function mapStateToProps(state,props) {
  let networksettings = [
    {
      title: "Trade Lifespan (OL Blocks)",
      id: "deposit",
      max: 1000,
      min: 10,
      placeholder:100
    },
    {
      title: "Settlement Period (OL Blocks)",
      id: "settlement",
      max: 1000,
      min: 10,
      placeholder:200
    },
  ];

  return {
    settings: state.settings.settings,
    networksettings
  };
}

// {isElectron() ? null : <Downloads/>}
// {isElectron() ? null : <li><a className='rightLink' rel="noopener noreferrer" target="_blank" href="https://forms.gle/BGcwQbbHFnPoD1Qk9" style={{color:'white'}}>feedback</a></li>}
//
export default connect(mapStateToProps, {setMarket,setAssetView})(withRouter(props => <Header {...props}/>));
